import React, { ReactText, useState } from 'react';
import { useFormik, FormikProvider, Form } from 'formik';
import Layout from 'antd/lib/layout/layout';
import { Spin } from 'antd';
import isEqual from 'lodash.isequal';
import PageTitle from '../../lib/page-title';
import FormControl from '../../lib/form-control';
import InputSelect from '../../lib/input-select';
import PrimaryButton from '../../lib/primary-button';
import './device-details.less';
import { createValidator } from '../../../utils/create-validator';
import { CreateDeviceDTO } from '../../../store/modules/devices/dto/create-device.dto';
import useDeviceDetails from './use-deviceDetails';
import DeleteModal from '../../lib/delete-modal';
import { useActions } from '../../providers/actions-provider/actions.context';
import SecondaryButton from '../../lib/secondary-button';
import LeavePageModal from '../../lib/leave-page-modal';
import PermissionProvider from '../../providers/permissionProvider';
import checkPermission from '../../../utils/permissions/permissions';

export const statuses = [
  { id: 0, name: 'active' },
  { id: 1, name: 'inactive' },
];

const DeviceDetails = () : JSX.Element => {
  const {
    initialValues,
    title,
    onSubmit,
    loading,
    groupsList,
  } = useDeviceDetails();
  const { devicesActions } = useActions();
  const formik = useFormik({
    initialValues,
    onSubmit,
    validate: (values) => createValidator(CreateDeviceDTO, values),
    enableReinitialize: true,
  });
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const { setFieldValue, values, isSubmitting } = formik;
  const formHasChanged = !isEqual(initialValues, values);

  const setStatus = (value:ReactText) => setFieldValue('status', value);

  const onConfirmDelete = () => {
    devicesActions.deleteDevice(values.id as number, false);
    setDeleteModalVisible(false);
  };
  const hasNotWritePermission = !checkPermission('devices', 'write');
  return (
    <Layout className="main-container">
      <PermissionProvider pageId="devices">
        {loading ? (<Spin size="large" />) : (
          <>
            {deleteModalVisible && (
              <DeleteModal
                text="Device"
                modalVisible={deleteModalVisible}
                onConfirm={onConfirmDelete}
                onCancel={() => setDeleteModalVisible(false)}
              />
            )}
            {formHasChanged && !isSubmitting && <LeavePageModal /> }

            <PageTitle title={title} back>
              {initialValues.name && (
                <SecondaryButton onClick={() => setDeleteModalVisible(true)} title="Delete Device" disabled={hasNotWritePermission} />
              )}
            </PageTitle>
            <FormikProvider value={formik}>
              <Form className="formik-form">
                <FormControl inputClassName="formik-form__input" name="name" label="Name" type="text" disabled={hasNotWritePermission} />
                <FormControl inputClassName="formik-form__input" name="description" label="Description (optional)" type="text" disabled={hasNotWritePermission} />
                <div className="formik-select__wrapper">
                  <InputSelect
                    disabled={hasNotWritePermission}
                    title="Group Code"
                    defaultValue={values.group_code}
                    fieldName="group_code"
                    onChange={(value: string | number) => {
                      setFieldValue('group_code', value);
                    }}
                    allowEmpty
                    data={groupsList}
                  />
                </div>
                <div className="formik-select__wrapper">
                  <InputSelect
                    disabled={hasNotWritePermission}
                    title="Status"
                    defaultValue={values.status}
                    fieldName="status"
                    onChange={setStatus}
                    data={statuses}
                  />
                </div>
                <PrimaryButton disabled={!formHasChanged || hasNotWritePermission} type="submit" className="formik-form__submit">
                  Save
                </PrimaryButton>
              </Form>
            </FormikProvider>
          </>
        )}
      </PermissionProvider>
    </Layout>
  );
};

export default DeviceDetails;
